angular.module("accordionAziendaGarante.components", [])
    .component("accordionAziendaGarante", {
        templateUrl: "ng/components/accordionAziendaGarante/accordionAziendaGarante.view.html",
        bindings: {
            aziendeGaranti: '=',
            financialModel: '<',
            guaranteeSelected: "=",
            firmatarioSelected: "&",
            snapshot: '<',
            portalRunned: '<',
            checkDatiComponent: "&"
        },
        controller: accordionAziendaGaranteController,
        controllerAs: 'accordionAziendaGaranteCtrl'
    })

function accordionAziendaGaranteController(
    $financialApiService,
    RiUserG,
    $rootScope,
    $timeout,
    $modalService
) {

    var self = this;

    self.$onInit = function () {

        self.searchObj = {

            pivaAzienda: ''

        }
        self.supportModel = {
            cfFirmatario: "",
            anagCancelToNsil: []
        }

        self.firmatarioSelected({
            firmatario: self.aziendeGaranti
        });

        checkAndPopolateAnagDeleted();
        validatePage();
    }

    self.searchAzienda = function () {
        self.searching = true;
        if (self.userAlreadyAdded(self.searchObj.pivaAzienda)) {
            return
        }
        var type = "G"

        self.PFresultsShown = true;
        $financialApiService.
            searchSubject(self.searchObj.pivaAzienda, type, 'rbCF')
            .then(function (response) {
                if (response && response.metadata && response.metadata.riUserG) {
                    self.tempAzienda = RiUserG.build(response.metadata.riUserG);
                } else {
                    var tempRiuserG = {
                        piva: self.searchObj.pivaAzienda
                    }
                    self.tempAzienda = RiUserG.build(tempRiuserG)
                }
            })
            .catch(function (error) {
                console.log('error', error);
            })
            .finally(function () {
                self.searching = false;
            })

    }

    self.userAlreadyAdded = function (piva) {
        var result = self.aziendeGaranti &&
            self.aziendeGaranti
                .find(function (el) {
                    return el.piva == piva
                });
        if (result) {
            $rootScope.$broadcast('addAlert', {
                text: 'AZIENDA_ALREADY_ADDED'
            });
            self.PFresultsShown = false;
            return true;
        }
    }

    self.addAziendaToList = function (Azienda) {
        //popolo l'oggetto luogoEsteso
        if (!self.tempAzienda.sedeLegale.luogoEsteso.nome && self.tempAzienda.sedeLegale.comune) {
            self.tempAzienda.sedeLegale.luogoEsteso.nome = self.tempAzienda.sedeLegale.comune;
            self.tempAzienda.sedeLegale.luogoEsteso.sigla = self.tempAzienda.sedeLegale.provincia;
            self.tempAzienda.sedeLegale.luogoEsteso.cap[0] = self.tempAzienda.sedeLegale.cap;
        }

        if (!self.tempAzienda.sedeConsegna.luogoEsteso.nome && self.tempAzienda.sedeConsegna.comune) {
            self.tempAzienda.sedeConsegna.luogoEsteso.nome = self.tempAzienda.sedeConsegna.comune;
            self.tempAzienda.sedeConsegna.luogoEsteso.sigla = self.tempAzienda.sedeConsegna.provincia;
            self.tempAzienda.sedeConsegna.luogoEsteso.cap[0] = self.tempAzienda.sedeConsegna.cap;
        }

        if (!self.tempAzienda.sedeFatturazione.luogoEsteso.nome && self.tempAzienda.sedeFatturazione.comune) {
            self.tempAzienda.sedeFatturazione.luogoEsteso.nome = self.tempAzienda.sedeFatturazione.comune;
            self.tempAzienda.sedeFatturazione.luogoEsteso.sigla = self.tempAzienda.sedeFatturazione.provincia;
            self.tempAzienda.sedeFatturazione.luogoEsteso.cap[0] = self.tempAzienda.sedeFatturazione.cap;
        }
        self.tempAzienda.datiIncompleti = !RiUserG.build(self.tempAzienda).isOk(false, false, false, false, false, true);
        self.aziendeGaranti.push(self.tempAzienda)

        if (self.tempAzienda.deleted) {
            self.supportModel.anagCancelToNsil.push(self.tempAzienda)
        }
        self.cleanUserFound();
        validatePage();
    }


    self.cleanUserFound = function () {
        self.tempAzienda = {};
        self.PFresultsShown = false;
        self.searchObj.pivaAzienda = "";
    }

    self.removeAzienda = function (azienda, index) {
        var indexAnagDeleted = self.supportModel.anagCancelToNsil
            .findIndex(function (element) {
                return element.piva == azienda.piva
            })
        if (indexAnagDeleted >= 0) {
            self.supportModel.anagCancelToNsil.splice(indexAnagDeleted, 1)
        }

        self.aziendeGaranti.splice(index, 1);
        self.firmatarioSelected({
            firmatario: self.aziendeGaranti
        });
    }

    self.editAzienda = function (azienda) {
        self.enableModal = true;
        self.currentAzienda = azienda;
        $timeout(function () {
            jQuery("#footerInstant").css("z-index", "-1");
            jQuery('.financial-leasing__footer').css("z-index", "-1");
            $modalService.openModal('censusAzienda');
        }, 100)
    }

    self.undoModal = function (azienda) {
        jQuery("#footerInstant").css("z-index", "2");
        jQuery('.financial-leasing__footer').css("z-index", "2");
        $modalService.closeModal('censusAzienda');
        self.enableModal = false;
        if (azienda.ndg) {
            azienda.datiIncompleti = !RiUserG.build(azienda).isOk(false, false, false, false, false, true);
        } else {
            azienda.datiIncompleti = !RiUserG.build(azienda).isOk(false, false, false, true, false);
        }
        validatePage();
    }


    self.saveUpdatedData = function (azienda) {
        jQuery(".alb-scroll.recovery-scroll").mCustomScrollbar("scrollTo", 0); //posiziona la scollBar in top ad ogni cambio vista
        if (azienda.ndg) {
            azienda.datiIncompleti = !RiUserG.build(azienda).isOk(false, false, false, false, false, true);
        } else {
            azienda.datiIncompleti = !RiUserG.build(azienda).isOk(false, false, false, true, false);
        }
        var indexOfSave = self.aziendeGaranti &&
            self.aziendeGaranti.findIndex(function (element) {
                return element.piva == azienda.piva
            })
        self.aziendeGaranti[indexOfSave] = azienda;

        self.firmatarioSelected({
            firmatario: self.aziendeGaranti
        });

        jQuery("#footerInstant").css("z-index", "2");
        jQuery('.financial-leasing__footer').css("z-index", "2");
        $modalService.closeModal("censusAzienda");
        self.enableModal = false;
        validatePage();
    }

    self.checkDisabledPiva = function (cf) {
        return self.guaranteeSelected && self.guaranteeSelected.some(function (element) {
            return element.cfGarante == cf.cf
        })
    }

    var checkAndPopolateAnagDeleted = function () {
        self.supportModel.anagCancelToNsil = self.aziendeGaranti && self.aziendeGaranti
            .filter(function (element) {
                return element.deleted == true;
            })
    }

    var validatePage = function () {
        var test = self.aziendeGaranti && !self.aziendeGaranti.every(function (element) {
            return element.datiIncompleti == true
        })
        self.checkDatiComponent({
            value: test
        })
    }
}